import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ConfigContext = createContext({
  features: { marketplace: false },
  product: { phase: "research_and_development", cost: "free" },
  loading: true,
});

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    features: { marketplace: false },
    product: { phase: "research_and_development", cost: "free" },
    loading: true,
  });

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const r = await api.get("/config");
        if (active) setConfig({ ...r.data, loading: false });
      } catch {
        if (active) setConfig((c) => ({ ...c, loading: false }));
      }
    })();
    return () => { active = false; };
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
export const useMarketplaceEnabled = () => useContext(ConfigContext).features?.marketplace === true;
